var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-box"},[_c('QRCode',{attrs:{"order":_vm.order}}),_c('Tracking',{attrs:{"order":_vm.order}}),_c('v-spacer'),_c('div',{staticClass:"d-flex flex-row"},[_c('Conversation',{attrs:{"order":_vm.order}}),_c('ReviewBtn',{attrs:{"order":_vm.order}}),_c('DetailBtn',{attrs:{"order":_vm.order}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }